import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Clock, AlertCircle, Scale, Shield, CreditCard } from 'lucide-react';

const ConditionsGenerales = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="pt-32 pb-16 px-4"
    >
      <div className="container mx-auto max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-8 text-gray-900">Conditions Générales de Vente</h1>

        <div className="space-y-8">
          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <FileText className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Préambule</h2>
            </div>
            <p className="mb-4">
              Les présentes conditions générales de vente s'appliquent à toutes les prestations de services 
              conclues par DIAGNOSTI-K auprès des clients professionnels ou particuliers.
            </p>
            <p>
              Le fait de faire appel à nos services implique l'adhésion entière et sans réserve du client 
              à ces conditions générales de vente.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Scale className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Services proposés</h2>
            </div>
            <p className="mb-4">DIAGNOSTI-K propose les services suivants :</p>
            <ul className="list-disc list-inside space-y-2">
              <li>Diagnostic de Performance Énergétique (DPE)</li>
              <li>Diagnostic Amiante</li>
              <li>Diagnostic Électricité</li>
              <li>Diagnostic Gaz</li>
              <li>Diagnostic Termites</li>
              <li>Mesurage Carrez</li>
              <li>Diagnostic Plomb</li>
              <li>État des Risques et Pollutions (ERP)</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Clock className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Commande et exécution</h2>
            </div>
            <p className="mb-4">
              Toute commande doit faire l'objet d'une confirmation écrite (devis signé) ou d'un accord 
              explicite du client.
            </p>
            <p className="mb-4">
              Le client s'engage à :
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Fournir tous les documents et informations nécessaires à la réalisation des diagnostics</li>
              <li>Garantir l'accès aux locaux</li>
              <li>Être présent ou se faire représenter lors de la visite</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <CreditCard className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Prix et paiement</h2>
            </div>
            <p className="mb-4">
              Les prix sont établis selon le tarif en vigueur au jour de la commande. Ils sont exprimés 
              en euros et sont soumis à la TVA au taux en vigueur.
            </p>
            <p className="mb-4">
              Le paiement est exigible immédiatement après la réalisation de la prestation. Les modes de 
              paiement acceptés sont :
            </p>
            <ul className="list-disc list-inside space-y-2">
              <li>Carte bancaire</li>
              <li>Virement bancaire</li>
              <li>Chèque</li>
              <li>Espèces (dans la limite légale)</li>
            </ul>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <AlertCircle className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Responsabilité</h2>
            </div>
            <p className="mb-4">
              DIAGNOSTI-K s'engage à réaliser les prestations selon les règles de l'art et de la meilleure 
              manière, conformément aux dispositions légales et réglementaires en vigueur.
            </p>
            <p>
              La responsabilité de DIAGNOSTI-K ne peut être engagée qu'en cas de faute ou de négligence 
              prouvée et est limitée aux préjudices directs à l'exclusion de tout préjudice indirect, 
              de quelque nature que ce soit.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <div className="flex items-center mb-6">
              <Shield className="h-6 w-6 text-dk-blue mr-3" />
              <h2 className="text-xl font-semibold text-gray-900">Assurance et garanties</h2>
            </div>
            <p className="mb-4">
              DIAGNOSTI-K déclare avoir souscrit une assurance responsabilité civile professionnelle 
              auprès d'une compagnie notoirement solvable et maintenir cette couverture d'assurance 
              pendant toute la durée de son activité professionnelle.
            </p>
            <p>
              Les diagnostics sont établis sur la base des textes légaux et réglementaires existants 
              le jour de la visite.
            </p>
          </section>

          <section className="bg-white rounded-lg shadow-lg p-6 md:p-8">
            <h2 className="text-xl font-semibold mb-4 text-gray-900">Droit applicable et litiges</h2>
            <p className="mb-4">
              Les présentes conditions générales sont soumises au droit français. En cas de litige, 
              une solution amiable sera recherchée avant toute action judiciaire.
            </p>
            <p>
              À défaut d'accord amiable, tout différend sera soumis aux tribunaux compétents du ressort 
              du siège social de DIAGNOSTI-K.
            </p>
          </section>
        </div>
      </div>
    </motion.div>
  );
};

export default ConditionsGenerales;